import { useSupabaseTable } from './useSupabaseTable';

export function useEmpresas() {
  return useSupabaseTable('empresas', { orderBy: 'nome_fantasia', ascending: true });
}
